import React from "react";
import styled from "styled-components";
import Fade from "react-reveal/Fade";

function AboutMe() {
  return (
    <SectionTwo>
      <Fade left>
        <Subtitle>
          <h1 className="text_shadows" id="two">About me</h1>
        </Subtitle>
      </Fade>
      <AboutMeSect>
        <Fade left>
          <ImageInfo src="/images/programmer.gif" />
        </Fade>
        <AboutInfo>
          <Fade duration={1000} top>
            <AboutTitle>
              Frontend developer with over 2+ years of experience. I follow the
              principles of writing code and perform tasks professionally.
              Knowledge consolidated in the work, participated in a startup (platform for learning), freelance, IT company. My duties included:
              <br />
              -development of new functionality, support of the old one.
              <br />
              -layout 
              <br />
              -refactoring
              <br />
              -code review
              <br />
              -validation
              <br />
              -authorization
              <br />
              and much more...
              <br />
              <Fade top>
            <a target="_blank" rel="noreferrer" href="https://disk.yandex.ru/i/Iy7D0BiXjhXsSQ">
              <DownloadCv>download resume</DownloadCv>
            </a>
          </Fade>
            </AboutTitle>
          </Fade>
        </AboutInfo>
      </AboutMeSect>
    </SectionTwo>
  );
}

export default AboutMe;

const AboutMeSect = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const SectionTwo = styled.div`
  width: 100vw;
`;

const AboutInfo = styled.div`
  letter-spacing: 1.2px;
  font-size: 18px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    flex-direction: column;
  }
`;

const ImageInfo = styled.img`
  width: 400px;
  border-radius: 60px;
  margin-right: 20px;
  @media (max-width: 768px) {
    width: 200px;
    margin: 15px auto;
  }
`;

const DownloadCv = styled.button`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 15px;
  background: #55198b;
  color: #fff;
  width: 150px;
  height: 56px;
  cursor: pointer;
  padding: 15px;
  border: none;
  border-radius: 5px;
  transition: background 0.3s ease-in-out 0s;
  &:hover {
    transition: all 0.3s ease-in 0s;
    background: #f5f11c;
    color: #000;
  }
  a {
    text-decoration: none;
    color: #fff;
    &:hover {
      color: #000;
    }
  }
  @media (max-width: 768px) {
    margin-top: 30px;
    position: static;
  }
`;

const AboutTitle = styled.p`
  position: relative;
  text-align: left;
  font-size: 18px;
  padding: 0 20px;
  line-height: 1.5;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Subtitle = styled.div`
  font-size: 22px;
`;
